<div class="container">
  <ng-container *ngIf="step === 'followup'">
    <h2>Muchas gracias por su respuesta</h2>
    <p>
      Apreciamos enormemente el tiempo empleado para trasladarnos su opinión,
      esto nos ayuda a nuestra mejora constante.
    </p>
    <p>
      Si lo desea, también puede comentarnos cuál es su valoración al respecto
      de la empresa:
    </p>
    <h3>¿Cuál es su grado de satisfacción general con respecto a Gar-San?</h3>
    <div class="smiley-row">
      <button (click)="handleFollowupVote(1)">😡</button>
      <button (click)="handleFollowupVote(2)">😞</button>
      <button (click)="handleFollowupVote(3)">😐</button>
      <button (click)="handleFollowupVote(4)">😊</button>
      <button (click)="handleFollowupVote(5)">😍</button>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 'done'">
    <h2>¡Muchas Gracias!</h2>
    <p>Su opinión nos ayuda a crecer</p>
  </ng-container>
</div>
